export default __webpack_public_path__ + "static/media/GA.9515ea75.svg";